/**
 * Constants for Jet Card Program Types and Card Types
 */

export const PROGRAM_TYPES = {
  ACCESS_PASS: 'AccessPass',
  ACCESS_PLUS: 'AccessPlus',
} as const;

export const CARD_TYPES = {
  FLIGHT_HOURS: 'FlightHours',
  FLIGHT_FUNDS: 'FlightFunds',
  ALL_IN: 'All In',
  ALL_ACCESS: 'All Access',
} as const;

export type ProgramType = typeof PROGRAM_TYPES[keyof typeof PROGRAM_TYPES];
export type CardType = typeof CARD_TYPES[keyof typeof CARD_TYPES];
